import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const MediaItem = ({ item, mediaType, status, style }) => {
  const [showNotePopup, setShowNotePopup] = useState(false);
  const popupRef = useRef(null);
  
  // Determine the ID field based on media type
  const mediaId = mediaType === 'anime' ? 'animeId' : 'mangaId';
  
  // Get appropriate image
  const imageUrl = item[mediaId]?.images?.webp?.image_url || item[mediaId]?.images?.webp?.imageUrl || item[mediaId]?.images?.jpg?.image_url || item[mediaId]?.images?.jpg?.imageUrl || '/placeholder.jpg';
  
  // Get title
  const title = item[mediaId]?.title_english || item[mediaId]?.title || `Unknown ${mediaType === 'anime' ? 'Anime' : 'Manga'}`;
  
  // Get type (TV, Movie, Manga, etc.)
  const type = item[mediaId]?.type || mediaType;
  
  // Check if item has a note
  const hasNote = item.notes && item.notes.trim() !== '';

  // Get the actual ID for constructing the link URL
  const detailId = item[mediaId]?.id;
  
  // The URL to navigate to
  const detailUrl = detailId ? `/${mediaType}/${detailId}` : '#';
  
  // Handle clicks outside the popup to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowNotePopup(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  // Progress or rating depending on status
  const getProgressDisplay = () => {
    if (status === 'completed') {
      return (
        <span className="completed-info">
          <span className="rating-display">
            {item.rating ? `★ ${item.rating}/10` : 'Not rated'}
          </span>
          {hasNote && (
            <button 
              className="note-toggle-btn"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault(); // Prevent navigation when clicking the note button
                setShowNotePopup(true);
              }}
            >
              See note
            </button>
          )}
        </span>
      );
    }
    
    if (mediaType === 'anime') {
      return `Episode ${item.currentEpisode}/${item[mediaId]?.episodes || '?'}`;
    } else {
      return `Ch ${item.currentChapter}${item[mediaId]?.chapters ? '/' + item[mediaId].chapters : ''}`;
    }
  };
  
  return (
    <Link to={detailUrl} className="favorite-item" style={style} key={mediaId}>
      <div className="favorite-thumb">
        <img 
          src={imageUrl}
          alt={title}
        />
      </div>
      <div className="favorite-details">
        <h4 className="favorite-title">{title}</h4>
        <div className="favorite-meta">
          <span className="favorite-type">{type}</span>
          <div className="favorite-score">
            {getProgressDisplay()}
          </div>
        </div>
      </div>
      
      {showNotePopup && hasNote && (
        <div 
          className="note-popup-overlay" 
          onClick={(e) => {
            e.preventDefault(); // Prevent navigation
            e.stopPropagation();
          }}
        >
          <div 
            className="note-popup" 
            ref={popupRef} 
            onClick={(e) => {
              e.preventDefault(); // Prevent navigation
              e.stopPropagation();
            }}
          >
            <div className="note-popup-header">
              <h4>{title} - Note</h4>
              <button 
                className="close-popup-btn"
                onClick={(e) => {
                  e.preventDefault(); // Prevent navigation
                  e.stopPropagation();
                  setShowNotePopup(false);
                }}
              >
                ×
              </button>
            </div>
            <div className="note-popup-content">
              {item.notes}
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

export default MediaItem;